import React from 'react';
import { ZdsDivider, ZdsItem } from '@zig-design-system/ui-components-react';
import Translation from '../../../Shared/components/Translation';
const OtherResult = ({ hit }) => {
    return (React.createElement("div", null,
        React.createElement(ZdsItem, { link: hit._source.url },
            hit._type === 'typo3_news' && (React.createElement("div", { slot: "label-text" },
                React.createElement(Translation, { item: "tx_zigsitepackage.search.news" }))),
            React.createElement("div", { slot: "primary-text", className: "zds-bold zds-truncate" }, hit._source.title),
            React.createElement("div", { slot: "secondary-text", className: "zds-truncate", dangerouslySetInnerHTML: { __html: hit._source.fields.description || hit._source.content } })),
        React.createElement(ZdsDivider, { className: "zds-margin-y-0" })));
};
export default OtherResult;
